  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
    <app-header
    *ngIf="!isVendorConsole && !hideHeader && !isFullscreenConsole "
    [showToggle]="!isOver"
    (toggleCollapsed)="toggleCollapsed()"
    (toggleMobileNav)="sidenav.toggle()">
    </app-header>
    <main class="pageWrapper" [class.vc-fullscreen]="isVendorConsole || hideHeader || isFullscreenConsole">
      <!-- ============================================================== -->
      <!-- Outlet -->
      <!-- ============================================================== -->
      <router-outlet></router-outlet>
    </main>
